var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/phone"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.702 3.751a7.85 7.85 0 0 1 5.547 5.547m-6.36-2.519a4.694 4.694 0 0 1 3.332 3.333m-9.076 1.95a8.194 8.194 0 0 0 3.822 3.812.784.784 0 0 0 .775-.059l2.45-1.636a.774.774 0 0 1 .745-.069l4.586 1.97a.774.774 0 0 1 .47.814A4.704 4.704 0 0 1 16.33 21 13.329 13.329 0 0 1 3 7.671a4.704 4.704 0 0 1 4.106-4.665.774.774 0 0 1 .814.47l1.97 4.597a.784.784 0 0 1-.06.735l-1.636 2.49a.784.784 0 0 0-.049.764Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e6690f982968577f00b72f0e09c0decf.svg";
export { ForwardRef as ReactComponent };